module.exports = __webpack_public_path__ + "img/pcgame.5d9d1903.jpg";